import React from 'react'

const ProductTitle = ({title}) => (
  <h1 className="txt-dsp-2 -nopad-bottom -nomargin-bottom">{title}</h1>
);

export default ProductTitle;



// WEBPACK FOOTER //
// ./src/components/ProductTitle/index.js